module.exports = __webpack_public_path__ + "static/dancevideo-34a2b14c8bb8d724938cea03e2fa5a83.mp4";